import { Intestazione } from './intestazione-pratica/intestazione';
import { Pratica } from './pratica';

export class PraticaBase extends Pratica {
    intestazione: Intestazione;
    idSezioneClassificazione?: string;
}
